module.exports = __webpack_public_path__ + "img/返回顶部、置顶.3ad42575.png";